import {
  createAlert,
  deleteAlert,
  updateAlert,
} from "../../graphql/mutations";
import {
  alertsByAgent,
  alertsByWorkspace,
  getAlert,
} from "../../graphql/queries";
import { makeGraphQLRequest } from "..";

const createAlert_ = async (object) => {
  return makeGraphQLRequest({
    query: createAlert,
    variables: { input: object },
  });
};

const getAlert_ = async (id) => {
  return makeGraphQLRequest({
    query: getAlert,
    variables: { id },
  });
};

const updateAlert_ = async (id, _properties = {}) => {
  const original = await getAlert_(id);
  return makeGraphQLRequest({
    query: updateAlert,
    variables: {
      input: {
        id,
        _version: original?.data?.getAlert?._version,
        ..._properties,
      },
    },
  });
};

const deleteAlert_ = async (id) => {
  const original = await getAlert_(id);
  return makeGraphQLRequest({
    query: deleteAlert,
    variables: {
      input: {
        id,
        _version: original?.data?.getAlert?._version,
      },
    },
  });
};

const getAlertsByWorkspace_ = async (workspaceID) => {
  let items = [];
  let nextToken = null;
  do {
    const result = await makeGraphQLRequest({
      query: alertsByWorkspace,
      variables: {
        workspaceID,
        limit: 500,
        nextToken,
      },
    });
    const data = result?.data?.alertsByWorkspace;
    items = items.concat(data?.items || []);
    nextToken = data?.nextToken;
  } while (nextToken);
  return items.filter((u) => u?._deleted !== true);
};

const getAlertsByAgent_ = async (agentID) => {
  let items = [];
  let nextToken = null;
  do {
    const result = await makeGraphQLRequest({
      query: alertsByAgent,
      variables: {
        agentID,
        limit: 500,
        nextToken,
      },
    });
    const data = result?.data?.alertsByAgent;
    items = items.concat(data?.items || []);
    nextToken = data?.nextToken;
  } while (nextToken);
  return items.filter((u) => u?._deleted !== true);
};

export default {
  createAlert: createAlert_,
  updateAlert: updateAlert_,
  deleteAlert: deleteAlert_,
  getAlert: getAlert_,
  getAlertsByWorkspace: getAlertsByWorkspace_,
  getAlertsByAgent: getAlertsByAgent_,
};
